﻿import {DataGroup, DataType} from "@tnt/mate-api";

import {RouteComponent} from "vue-router";
import {useAuth} from '../utils/useAuth';

declare type Lazy<T> = () => Promise<T>;

export interface ComponentMapping {
    path?: string;
    alias?: string;
    component: Lazy<RouteComponent>;
    props?: any;
    related?: Record<string, ComponentMapping>;
    meta?: any;
}

export const mappings: Record<string, ComponentMapping> = {

    "ArticleQuickSelection": {
        component: ()=> <Promise<any>>import("./settings/ArticleQuickSelectionIndex.vue"),
        related: {
            "ArticleQuickSelectionEditor": {
                path: "/settings/pos/article-quick-selections/:id",
                component:  ()=> <Promise<any>>import("./settings/ArticleQuickSelection.vue"),
                props: (route: any) => ({
                    id: route.params.id,
                }),
                meta: {
                    // LGB: just temporay for quick solution
                    ignorePermissions: true,
                    allowAnonymous: true,
                }
            }
        }
    },
    "QuickAccess": {
        component:  ()=> <Promise<any>> import("./settings/QuickAccessIndex.vue"),
        related: {
            "QuickAccessEditor": {
                path: "/settings/pos/quick-accesses/:id",
                component:  ()=> <Promise<any>> import("./settings/QuickAccess.vue"),
                props: (route: any) => ({
                    id: route.params.id,
                }),
                meta: {
                    // LGB: just temporay for quick solution
                    ignorePermissions: true,
                    allowAnonymous: true,
                }
            }
        }
    },
    "Bridge": {
        component:  ()=> <Promise<any>> import("./diagnostics/Bridge.vue")
    },
    //"BridgeDetails": {
    // path: "/service/bridge/:id",
    //component:  ()=> <Promise<any>> import("./diagnostics/BridgeDetails.vue"),
    // props: (route: any) => ({
    //     uid: route.params.uid?.toLowerCase()     
    // })
    //},
    "Configuration": {
        path: "/settings/:target/configuration",
        //component:  ()=> <Promise<any>> import("./settings/Configuration.vue")
        component:  ()=> <Promise<any>> import("./settings/FramedConfiguration.vue"),
        props: (route: any) => ({
            target: route.params.target?.toLowerCase()
        })
    },
    "Monitoring": {
        component:  ()=> <Promise<any>> import("./diagnostics/FramedMonitoring.vue")
    },
    "DatabaseUsage": {
        component:  ()=> <Promise<any>> import("./diagnostics/DatabaseUsage.vue")
    },
    "DocumentViewer": {
        path: "/document/:documentGroup/:documentType",
        component:  ()=> <Promise<any>> import("./documents/DocumentGrid.vue"),
        props: (route: any) => ({
            documentGroup: route.params.documentGroup?.toLowerCase(),
            documentType: route.params.documentType?.toLowerCase(),
            query: route.query
        })
    },
    "Message": {
        component:  ()=> <Promise<any>> import("./chat/Chats.vue"),
    },
    "ReceiptTemplate": {
        component:  ()=> <Promise<any>> import("./settings/XmlReceiptTemplates.vue")
    },

    "ReportGrid": {
        path: "/report/:reportGroup/:reportType",
        component:  ()=> <Promise<any>> import("./report/ReportGrid.vue"),
        props: (route: any) => ({
            reportGroup: route.params.reportGroup?.toLowerCase(),
            reportType: route.params.reportType?.toLowerCase(),
            query: route.query
        })
    },
    "ReportExport": {
        path: "/report/export/:reportGroup/:reportType",
        component:  ()=> <Promise<any>> import("./report/ReportExport.vue"),
        props: (route: any) => ({
            reportGroup: route.params.reportGroup?.toLowerCase(),
            reportType: route.params.reportType?.toLowerCase(),
            query: route.query
        })
    },
    "MasterData": {
        path: "/data/:dataGroup/:dataType",
        component:  ()=> <Promise<any>> import("./data/DataGrid.vue"),
        props: (route: any) => ({
            dataGroup: route.params.dataGroup?.toLowerCase(),
            dataType: route.params.dataType?.toLowerCase(),
            query: route.query
        })
    },    
    "ContactTasks":{
        //path: "/data/:dataGroup",
        component:  ()=> <Promise<any>> import("./data/DataGrid.vue"),
        props: (route: any) => ({
            dataGroup: DataGroup.PosPreferences,
            dataType: DataType.ContactTask,
            query: route.query
        })
    },    
    "DocumentLocks":{
        //path: "/data/:dataGroup",
        component:  ()=> <Promise<any>> import("./data/DataGrid.vue"),
        props: (route: any) => ({
            dataGroup: DataGroup.PosOperating,
            dataType: DataType.DocumentLock,
            query: route.query
        })
    },
    "PromotionEditor": {
        component:  ()=> <Promise<any>> import("./data/DataGrid.vue"),
        props: (route: any) => ({
            dataGroup: DataGroup.Campaigns,
            dataType: DataType.Promotion,
            query: route.query
        })
    },
    "RandomScanSheet": {
        component: () => <Promise<any>> import("./tools/RandomScanSheet.vue")
    },
    "RetailIcons": {
        component:  ()=> <Promise<any>> import("./tools/RetailIcons.vue")
    },
    "ShoppingCart": {
        component:  ()=> <Promise<any>> import("./dev-tools/ShoppingCart.vue")
    },
    "VisualReceiptDesigner": {
        path: "/visual-receipt-designer/:documentType",
        component: ()=> <Promise<any>> import("@tnt/receipt-design"),        
        props: (route: any) => {
            const {user} = useAuth();
            return {
                user: user.value,
                documentType: route.params.documentType
            };
        }
    },
    "UnprocessedDocuments": {
        component:  ()=> <Promise<any>> import("./diagnostics/UnprocessedDocuments.vue")
    },
    "TerminalServer": {
        component:  ()=> <Promise<any>> import("./diagnostics/TerminalServer.vue")
    },
    "ServerLog": {
        component:  ()=> <Promise<any>> import("./logging/ServerLog.vue")
    },
    "TerminalServerLog": {
        component:  ()=> <Promise<any>> import("./logging/TerminalServerLog.vue")
    },
    "Swagger": {
        component:  ()=> <Promise<any>> import("./tools/Swagger.vue")
    },
    "RapiDoc": {
        component:  ()=> <Promise<any>> import("./tools/RapiDoc.vue")
    },
    "Dropzone": {
        component:  ()=> <Promise<any>> import("./tools/Dropzone.vue")
    },
    "ReportEngine": {
        component:  ()=> <Promise<any>> import("./data/DataGrid.vue"),
        props: (route: any) => ({
            dataGroup: DataGroup.PosPreferences,
            dataType: DataType.ReportEngine,
            query: route.query
        })
    }
}
